
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  data() {
    // controlla login
    if (!myApp.user || !myApp.user.id) {
      this.$app.panel.open('.panel-left');
      return;
    } // controlla profilo


    if (!myApp.checkUser()) {
      this.$app.dialog.alert(lng.profileIncomplete, () => {
        this.$router.navigate('/profile/');
      });
      return;
    }

    return {
      lng: lng,
      menu: {
        categories: [],
        menu_settings: {}
      },
      idpoi: this.$route.params.idpoi,
      currency: {
        euro: 'EUR',
        pound: 'GBP',
        dollar: 'USD'
      },
      order: {},
      order_price: 0.00,
      deliveryAddresses: [],
      deliveryTS: null,
      info: {},
      ora: new Date().getHours(),
      oraMin: 0,
      oraMax: 23,
      dataDelivery: 'oggi',
      isClosed: false,
      poi: myApp.currentPoi || {
        info: {}
      },
      onlyView: this.$route.query.onlyview ? true : false,
      booking: this.$route.query.booking ? true : false,
      foodDelivery: this.$route.query.food_delivery ? 'hidden' : '',
      map: null
    };
  },

  methods: {
    myDistance: async function (addressId) {
      // controlla distanza massima
      // self.poi.menu_settings.delivery_max_radius
      const self = this,
            app = this.$app,
            $ = this.$;
      const address = self.deliveryAddresses.find(x => x.id == addressId);
      const geocoder = new google.maps.Geocoder();
      self.map = self.map || new L.Map('map____5');
      return new Promise(function (resolve) {
        geocoder.geocode({
          address: address.val
        }, (a, b) => {
          console.log(a, b);

          if (b == 'OK') {
            const latlng = a[0].geometry.location.toJSON();
            const distance = self.map.distance(latlng, self.poi.latlng);
            resolve(distance);
          } else {
            resolve(false);
          }
        });
      });
    },
    translate: async function (lng) {
      let q = [];
      let items = [];
      this.menu.categories.forEach(c => {
        c.items.forEach(item => {
          if (item.visible) {
            items.push({
              id: item.id,
              text: item.caption,
              type: 'caption'
            });
            items.push({
              id: item.id,
              text: item.description,
              type: 'description'
            });
            q.push(item.caption);
            q.push(item.description);
          }
        });
      });

      const originalLang = () => {
        items.forEach(e => {
          this.$('.item-' + e.id + '-' + e.type).html(e.text);
        });
      };

      if (lng !== '-') {
        const APIKey = 'AIzaSyB8AY9p2GiPEq4iQ7gNmh5IRqI7MfKyy28';
        const url = 'https://translation.googleapis.com/language/translate/v2?key=' + APIKey;
        const data = {
          target: lng,
          q: q,
          format: 'text'
        };
        const options = {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json'
          }
        };
        let res = await fetch(url, options);

        if (res.ok) {
          let tr = await res.json();
          tr.data.translations.forEach((e, i) => {
            this.$('.item-' + items[i].id + '-' + items[i].type).html(e.translatedText);
          });
        } else {
          originalLang();
        }
      } else {
        originalLang();
      }
    },

    showImage(ev) {
      const self = this,
            app = this.$app,
            $ = this.$,
            cat = $(ev.target).data('categoriesIndex'),
            itm = $(ev.target).data('index'),
            images = self.menu.categories[cat].items[itm].images;

      if (images.length) {
        app.photoBrowser.create({
          photos: images,
          popupCloseLinkText: lng.close
        }).open();
      }
    },

    bookingFor() {
      const self = this,
            app = this.$app,
            $ = this.$;
      const today = new Date();
      $('.page-content').scrollTop(900);
      const pickerInline = app.picker.create({
        toolbar: true,
        rotateEffect: true,
        value: [today.getMonth(), today.getDate(), today.getFullYear(), today.getHours(), today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes()],
        formatValue: function (values, displayValues) {
          return displayValues[0] + ' ' + values[1] + ', ' + values[2] + ' ' + values[3] + ':' + values[4];
        },
        cols: [// Months
        {
          values: '0 1 2 3 4 5 6 7 8 9 10 11'.split(' '),
          displayValues: myApp.months[lng.language],
          textAlign: 'left'
        }, // Days
        {
          values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]
        }, // Years
        {
          values: function () {
            var arr = [];

            for (let i = today.getFullYear(); i <= today.getFullYear() + 2; i++) {
              arr.push(i);
            }

            return arr;
          }()
        }, // Space divider
        {
          divider: true,
          content: '&nbsp;&nbsp;'
        }, // Hours
        {
          values: function () {
            var arr = [];

            for (var i = 0; i <= 23; i++) {
              arr.push(i);
            }

            return arr;
          }()
        }, // Divider
        {
          divider: true,
          content: ':'
        }, // Minutes
        {
          values: function () {
            var arr = [];

            for (var i = 0; i <= 59; i++) {
              arr.push(i < 10 ? '0' + i : i);
            }

            return arr;
          }()
        }],
        on: {
          change: function (picker, values, displayValues) {
            var daysInMonth = new Date(picker.value[2], picker.value[0] * 1 + 1, 0).getDate();

            if (values[1] > daysInMonth) {
              picker.cols[1].setValue(daysInMonth);
            }

            const d = new Date();
            d.setMonth(values[0]);
            d.setDate(values[1]);
            d.setFullYear(values[2]);
            d.setHours(values[3]);
            d.setMinutes(values[4]);
            d.setSeconds(0);

            if (self.checkDateTime(d)) {
              self.deliveryTS = d.getTime();
              $('#datetime-booking').text(d.toLocaleString()).removeClass('text-color-red');
            } else {
              self.deliveryTS = null;
              $('#datetime-booking').text(d.toLocaleString() + ' - ' + lng.closed.toUpperCase()).addClass('text-color-red');
            }

            self.$update();
          }
        }
      });
      pickerInline.open();
    },

    paypal() {
      const self = this,
            app = this.$app,
            $ = this.$;
      let mode = self.booking ? 'booking' : '';
      if ($('#order-delivery').prop('checked')) mode = 'delivery';else if ($('#order-takeaway').prop('checked')) mode = 'takeaway'; // ordine minimo

      if (mode == 'delivery' && self.order_price < self.menu.menu_settings.delivery_order_min) {
        return app.dialog.alert('Ordine minimo per delivery ' + this.cur + self.menu.menu_settings.delivery_order_min);
      } // indirizzo di consegna


      if (mode === 'delivery' && $('#delivery-address').val() == '-') {
        return app.dialog.alert(lng.deliveryAddrError);
      } // data e ora se oggi è chiuso


      if (!self.info.oggiAperto && !self.deliveryTS) {
        return app.dialog.alert(lng.order_text_5);
      }

      if (mode) invia();else {
        app.dialog.prompt(lng.tableNumber, invia);
      }

      function invia(tableNumber) {
        const order = {
          order: myApp.order,
          order_price: self.order_price,
          delivery_price: self.delivery_price,
          total_price: self.total_price,
          order_mode: mode,
          idpoi: self.idpoi,
          currency: self.cur,
          notes: $('#order_notes').val(),
          delivery_address: $('#delivery-address').val(),
          deliveryTS: self.deliveryTS,
          tableNumber: tableNumber || '',
          me: myApp.user,
          description: mode === 'booking' ? 'Booking ' + new Date(self.deliveryTS).toString() : ''
        }; // imposta preorder con tutti i dati

        myApp.server.post('imc/preorder', order).then(succ => {
          const url = 'https://infomycity.com/order/' + succ + '/' + (app.device.ios ? 'ios' : 'android');

          if (window.cordova && cordova.InAppBrowser) {
            const callback = function (ev) {
              if (ev.type == 'loadstart' && ev.url.match('infoMyCityOrderStatusCompleted')) {
                const paypal_capture_id = ev.url.substr(55);
                inAppBrowserRef.close();
                order.preorder_id = succ;
                order.paypal_capture_id = paypal_capture_id;
                app.dialog.alert('Il tuo ordine è stato inviato', () => {
                  app.popup.close();
                  myApp.order = null;
                  self.order = null;
                  self.order_price = 0;
                  self.delivery_price = 0;
                  self.total_price = 0;
                  self.$router.back();
                });
              } else if (ev.type == 'loadstart' && ev.url.match('infoMyCityOrderStatusAborted')) {
                inAppBrowserRef.close();
              }
            };

            const opt = 'location=no,toolbar=no' + ',hardwareback=no,hidenavigationbuttons=yes,zoom=no';
            const target = app.device.ios ? '_blank' : '_self';
            const inAppBrowserRef = cordova.InAppBrowser.open(url, target, opt);
            inAppBrowserRef.addEventListener('loadstart', callback);
            inAppBrowserRef.addEventListener('loadstop', callback);
            inAppBrowserRef.addEventListener('loaderror', callback);
            inAppBrowserRef.addEventListener('beforeload', callback);
            inAppBrowserRef.addEventListener('message', callback);
            inAppBrowserRef.addEventListener('exit', callback);
          } else {
            // solo per test
            window.open(url); // produzione
            //app.dialog.alert('Disabilitato nel web');
          }
        }).catch(err => {
          console.log(err);
          app.toast.show({
            text: lng.genericError,
            closeTimeout: 3000,
            cssClass: 'bg-color-red',
            position: 'bottom'
          });
        }).finally(() => {
          console.log('finally');
        });
      }
    },

    filter2(type) {
      switch (type) {
        case 'takeaway':
          if (!this.menu.takeaway) return;
          this.$('#filter-takeaway').prop('checked', true);
          this.filterTakeaway();
          break;

        case 'delivery':
          if (!this.menu.delivery) return;
          this.$('#filter-delivery').prop('checked', true);
          this.filterDelivery();
          break;

        case 'table':
          if (this.menu.menu_settings.takeaway_delivery_only || this.isClosed) return;
          this.$('#filter-all').prop('checked', true);
          this.filterAll();
          break;
      }

      this.$app.popup.close();
    },

    checkDateTime(date) {
      const w = date.getDay();

      if (myApp.currentPoi.info && myApp.currentPoi.info.weekdays && myApp.currentPoi.info.weekdays[w]) {
        return false;
      }

      const d = this.opened[w];
      let h = date.getHours() + '';
      let m = date.getMinutes() + '';
      if (h < 10) h = '0' + h;
      if (m < 10) m = '0' + m;
      const hm = h + ':' + m;

      if (d.a <= d.b && d.c <= d.d) {
        return (d.a || d.b) && hm >= d.a && hm <= d.b || (d.b || d.c) && hm >= d.c && hm <= d.d;
      } else if (d.a >= d.b && d.c <= d.d) {
        return (d.a || d.b) && hm >= d.a || hm <= d.b || (d.b || d.c) && hm >= d.c && hm <= d.d;
      } else if (d.a >= d.b && d.c >= d.d) {
        return (d.a || d.b) && hm >= d.a || hm >= d.b || (d.b || d.c) && hm >= d.c || hm <= d.d;
      } else if (d.a <= d.b && d.c >= d.d) {
        return (d.a || d.b) && hm >= d.a && hm <= d.b || (d.b || d.c) && hm >= d.c || hm <= d.d;
      }
    },

    deliveryToday() {
      this.dataDelivery = 'oggi';
      this.$('.deliveryToday').removeClass('button-outline').addClass('button-fill');
      this.$('.deliveryTomorrow').removeClass('button-fill').addClass('button-outline');
    },

    deliveryTomorrow() {
      this.dataDelivery = 'domani';
      this.$('.deliveryTomorrow').removeClass('button-outline').addClass('button-fill');
      this.$('.deliveryToday').removeClass('button-fill').addClass('button-outline');
    },

    deliveryNow() {
      this.$('.deliveryNow').removeClass('button-outline').addClass('button-fill');
      this.$('.deliveryFor').removeClass('button-fill').addClass('button-outline');
      this.deliveryTS = null;
      this.dataDelivery = 'oggi';
      this.$update();
    },

    deliveryFor() {
      this.$('.deliveryNow').removeClass('button-fill').addClass('button-outline');
      this.$('.deliveryFor').removeClass('button-outline').addClass('button-fill');
      this.$app.dialog.create({
        el: '.dialog-time',
        closeByBackdropClick: true
      }).open();
    },

    setHour() {
      //console.log(this.isClosed);
      if (this.isClosed) return;
      const d = new Date();

      if (this.dataDelivery == 'domani') {
        d.setDate(d.getDate() + 1);
      }

      const h = this.$app.range.get('.range-slider-hours').getValue();
      const m = this.$app.range.get('.range-slider-minutes').getValue();
      d.setHours(h);
      d.setMinutes(m);
      d.setSeconds(0);
      this.deliveryTS = d.getTime();
      this.$app.dialog.close();
      this.$update();
    },

    changeDeliveryAddr() {
      const self = this,
            app = this.$app,
            $ = this.$; //console.log($('#delivery-address-2').val());

      if ($('#delivery-address-2').val() == '-') {
        // pulisce form d'inserimento
        $('[name=delivery_address_id]').val('');
        $('[name=delivery_address]').val('');
        $('[name=delivery_cap]').val('');
        $('[name=delivery_city]').val('');
        $('[name=delivery_address_name]').val('');
        $('[name=delivery_phone]').val('');
        $('[name=delivery_default]').prop('checked', false);
      } else {
        const o = self.deliveryAddresses[$('#delivery-address-2').val()]; //console.log(o);

        $('[name=delivery_address_id]').val(o.id);
        $('[name=delivery_address]').val(o.address);
        $('[name=delivery_cap]').val(o.cap);
        $('[name=delivery_city]').val(o.city);
        $('[name=delivery_address_name]').val(o.address_name);
        $('[name=delivery_phone]').val(o.phone);
        $('[name=delivery_default]').prop('checked', o.default_addr ? true : false);
      }
    },

    insertDeliveryAddress() {
      const self = this,
            app = this.$app,
            $ = this.$;
      const inputRequired = ['delivery_address', 'delivery_cap', 'delivery_city', 'delivery_address_name', 'delivery_phone'];
      let err = false;

      for (let i in inputRequired) {
        const el = $('[name=' + inputRequired[i] + ']');

        if (!el.val()) {
          err = true;
        }
      }

      if (err) return app.dialog.alert(lng.errFields);
      const addr = $('[name=delivery_address_name]').val() + ' - ' + $('[name=delivery_address]').val() + ', ' + $('[name=delivery_cap]').val() + ', ' + $('[name=delivery_city]').val();
      const isDefault = $('[name=delivery_default]').prop('checked') ? 'selected' : '';
      app.preloader.show();
      myApp.server.post('imc/delivery_addr', {
        val: addr,
        id: $('#delivery-address-2').val() != '-' ? $('[name=delivery_address_id]').val() : '',
        address: $('[name=delivery_address]').val(),
        cap: $('[name=delivery_cap]').val(),
        city: $('[name=delivery_city]').val(),
        address_name: $('[name=delivery_address_name]').val(),
        phone: $('[name=delivery_phone]').val(),
        default_addr: isDefault
      }).then(succ => {
        //console.log(succ);
        if (succ.default_addr) {
          // rimuove impostazione di default
          for (let i in self.deliveryAddresses) {
            self.deliveryAddresses[i].default_addr = '';
          }
        } // aggiungi alla collection e aggiorna view


        self.deliveryAddresses.push(succ);
        self.$update(); // pulisce form d'inserimento

        $('[name=delivery_address_id]').val('');
        $('[name=delivery_address]').val('');
        $('[name=delivery_cap]').val('');
        $('[name=delivery_city]').val('');
        $('[name=delivery_address_name]').val('');
        $('[name=delivery_phone]').val('');
        $('[name=delivery_default]').prop('checked', false); // chiude popup d'inserimento

        app.popup.close('.popup-delivery-addr');
      }).catch(err => {
        console.log(err);
        app.toast.show({
          text: lng.genericError,
          closeTimeout: 3000,
          cssClass: 'bg-color-red',
          position: 'bottom'
        });
      }).finally(() => {
        app.preloader.hide();
      });
    },

    setDeliveryAddress() {
      const self = this,
            app = this.$app,
            $ = this.$;
      app.popup.open('.popup-delivery-addr');
    },

    getAddresses() {
      const self = this,
            app = this.$app,
            $ = this.$;
      myApp.server.get('imc/delivery_addr').then(succ => {
        console.log(succ);
        self.$setState({
          deliveryAddresses: succ
        });
      }).catch(err => {
        console.log(err); //app.toast.show({text: lng.genericError, closeTimeout: 3000, cssClass: 'bg-color-red', position: 'bottom'});
      });
    },

    getMenu(filter) {
      this.orderType = filter;
      const self = this,
            app = this.$app,
            $ = this.$;
      const f = filter ? '?f=' + filter : '';
      myApp.server.get('imc/menu/' + self.$route.params.idpoi + f).then(res => {
        for (let i in res.categories) {
          for (let ii in res.categories[i].items) {
            self.hasMenu = true;
            res.categories[i].items[ii].catIndex = i;
            res.categories[i].items[ii].images = res.categories[i].items[ii].images || (res.categories[i].items[ii].image ? [res.categories[i].items[ii].image] : []);
            let hasAllergens = false;

            for (let j in res.categories[i].items[ii].allergens) {
              if (res.categories[i].items[ii].allergens[j]) {
                hasAllergens = true;
                break;
              }
            }

            res.categories[i].items[ii].hasAllergens = hasAllergens;
          }
        }

        res.currency = self.currency[res.currency] ? self.currency[res.currency] : res.currency;
        self.$setState({
          menu: res,
          cur: res.currency
        }).then(() => {
          if (myApp.order) {
            for (let i in myApp.order) {
              const id = i.replace('#item-', '');
              const v = myApp.order[i].q || 0;
              $('#menu-item-q-' + id).text(v);
            }
          }
        });
      });
    },

    openPopup() {
      const $ = this.$,
            app = this.$app;

      if ($('#igetit').prop('checked') || this.booking) {
        app.popup.open('.popup-detail-order');
      } else {
        $('.page-content').scrollTop($('#card-disclaimer').offset().top, 500);
        app.dialog.alert(lng.orderMessageIGetIt);
      }
    },

    openExtend(id) {
      const self = this,
            app = this.$app,
            $ = this.$;
      $('.menu-item-extend').each((i, e) => {
        if ($(e).data('id') == id) $(e).toggleClass('hidden');else $(e).addClass('hidden');
      });
    },

    menuSubtract(e) {
      const self = this,
            app = this.$app,
            $ = this.$;
      const id = '#item-' + e;
      const item = myApp.order[id];
      if (!item) return;
      let q = (item.q || 0) - 1;
      if (q < 0) return;
      item.q = q;
      myApp.order[id] = item;
      $('#menu-item-q-' + e).text(q);
    },

    menuAdd(e) {
      const self = this,
            app = this.$app,
            $ = this.$;
      const id = '#item-' + e;
      const item = myApp.order[id] || JSON.parse($(id).val());
      let q = (item.q || 0) + 1;
      item.q = q;
      myApp.order[id] = item;
      $('#menu-item-q-' + e).text(q);
    },

    iGetIt() {
      const self = this,
            app = this.$app,
            $ = this.$;
      if ($('#igetit').prop('checked')) $('#btn-order').removeClass('hidden');else $('#btn-order').addClass('hidden');
    },

    reset() {
      myApp.order = {};
      this.$('.menu-item-order-q').text('0');
    },

    sendOrder: async function (method) {
      const self = this,
            app = this.$app,
            $ = this.$;
      let mode = '';
      if ($('#order-delivery').prop('checked')) mode = 'delivery';else if ($('#order-takeaway').prop('checked')) mode = 'takeaway'; // ordine minimo

      if (mode == 'delivery' && self.order_price < self.menu.menu_settings.delivery_order_min) {
        return app.dialog.alert('Ordine minimo per delivery ' + this.cur + self.menu.menu_settings.delivery_order_min);
      } // indirizzo di consegna


      if (mode === 'delivery' && $('#delivery-address').val() == '-') {
        return app.dialog.alert(lng.deliveryAddrError);
      } // data e ora se oggi è chiuso


      if (!self.info.oggiAperto && !self.deliveryTS) {
        return app.dialog.alert(lng.order_text_5);
      } // beach && disco


      if (['beach', 'disco'].indexOf(self.poi.type) !== -1) {
        mode = 'booking';
      } // controlla order locked 


      if ((mode == 'takeaway' || mode == 'delivery') && self.poi.info.order_locked) {
        return app.dialog.alert("Al momento non accettiamo ulteriori ordini");
      } // controlla distanza


      if (mode == 'delivery' && self.poi.menu_settings.delivery_max_radius) {
        let distance = await self.myDistance($('#delivery-address').val());

        if (distance !== false && distance / 1000 > self.poi.menu_settings.delivery_max_radius * 1) {
          return app.dialog.alert("Questo locale ha impostato una distanza massima per il delivery di " + self.poi.menu_settings.delivery_max_radius + " km");
        }
      }

      if (mode) invia();else {
        app.dialog.prompt(lng.tableNumber, invia);
      }

      function invia(tableNumber) {
        app.preloader.show();
        const api = 'imc/order';
        myApp.server.post(api, {
          order: myApp.order,
          order_price: self.order_price,
          delivery_price: self.delivery_price,
          total_price: self.total_price,
          order_mode: mode,
          idpoi: self.idpoi,
          currency: self.cur,
          notes: $('#order_notes').val(),
          delivery_address: $('#delivery-address').val(),
          deliveryTS: self.deliveryTS,
          tableNumber: tableNumber || ''
        }).then(succ => {
          app.dialog.alert('Il tuo ordine è stato inviato', () => {
            app.popup.close();
            myApp.order = null;
            self.order = null;
            self.order_price = 0;
            self.delivery_price = 0;
            self.total_price = 0;
            self.$router.back();
          });
        }).catch(err => {
          console.log(err);
          app.toast.show({
            text: lng.genericError,
            closeTimeout: 3000,
            cssClass: 'bg-color-red',
            position: 'bottom'
          });
        }).finally(() => {
          app.preloader.hide();
        });
      }
    },

    filterTakeaway() {
      const $ = this.$;

      if ($('#filter-takeaway').prop('checked')) {
        $('#filter-delivery').prop('checked', false);
        $('#filter-all').prop('checked', false);
        this.$setState({
          is_delivery: false
        });
      } else if (this.menu.menu_settings.takeaway_delivery_only) {
        $('#filter-delivery').prop('checked', true);
        this.$setState({
          is_delivery: true
        });
      } else {
        $('#filter-all').prop('checked', !$('#filter-delivery').prop('checked'));
      }

      this.filter();
    },

    filterDelivery() {
      const $ = this.$;

      if ($('#filter-delivery').prop('checked')) {
        $('#filter-takeaway').prop('checked', false);
        $('#filter-all').prop('checked', false);
        this.$setState({
          is_delivery: true
        });
      } else if (this.menu.menu_settings.takeaway_delivery_only) {
        $('#filter-takeaway').prop('checked', true);
        this.$setState({
          is_delivery: false
        });
      } else {
        this.$setState({
          is_delivery: false
        });
        $('#filter-all').prop('checked', !$('#filter-takeaway').prop('checked'));
      }

      this.filter();
    },

    filterGlutenfree() {// ...
    },

    filterAll() {
      const $ = this.$;

      if ($('#filter-all').prop('checked')) {
        $('#filter-takeaway').prop('checked', false);
        $('#filter-delivery').prop('checked', false);
        this.$setState({
          is_delivery: false
        });
      } else {
        const v = $('#filter-takeaway').prop('checked') || $('#filter-delivery').prop('checked');
        $('#filter-all').prop('checked', !v);
      }

      this.filter();
    },

    filter() {
      const f = [],
            $ = this.$;
      myApp.order = {};
      $('.menu-item-order-q').text('0');
      if ($('#filter-takeaway').prop('checked')) f.push('takeaway');
      if ($('#filter-delivery').prop('checked')) f.push('delivery');
      if ($('#filter-glutenfree').prop('checked')) f.push('glutenfree');
      if ($('#filter-all').prop('checked')) f.push('onsite');

      if (f.length) {
        this.getMenu(f.join('|'));
      } else {
        this.getMenu();
      }
    },

    setDelivery(e) {
      if (!this.$('#order-delivery').prop('checked') && !this.$('#order-takeaway').prop('checked')) {
        this.$(e.target).prop('checked', true);
      }

      const isDelivery = this.$('#order-delivery').prop('checked');
      this.$setState({
        is_delivery: isDelivery
      });
    },

    updateInfo() {
      const self = this,
            app = this.$app,
            $ = this.$;

      if (self.info.oggiAperto && !self.isClosed) {
        $('.deliveryToday').removeClass('button-outline').addClass('button-fill');
        $('.deliveryTomorrow').removeClass('button-fill').addClass('button-outline');
        $('.deliveryNow').removeClass('button-fill').addClass('button-outline').addClass('disabled');
        $('.deliveryFor').removeClass('button-outline').addClass('button-fill');
      } else if (self.info.oggiAperto) {
        $('.deliveryToday').removeClass('button-outline').addClass('button-fill');
        $('.deliveryTomorrow').removeClass('button-fill').addClass('button-outline');
        $('.deliveryNow').removeClass('button-fill').addClass('button-outline').addClass('disabled');
        $('.deliveryFor').removeClass('button-outline').addClass('button-fill');
      } else if (self.info.domaniAperto) {
        $('.deliveryToday').removeClass('button-fill').addClass('button-outline').addClass('disabled');
        $('.deliveryTomorrow').removeClass('button-outline').addClass('button-fill');
        $('.deliveryNow').removeClass('button-fill').addClass('button-outline').addClass('disabled');
        $('.deliveryFor').removeClass('button-outline').addClass('button-fill');
        self.dataDelivery = 'domani';
      } else {
        $('.deliveryToday').removeClass('button-fill').addClass('button-outline').addClass('disabled');
        $('.deliveryTomorrow').removeClass('button-fill').addClass('button-outline').addClass('disabled');
      }
    }

  },

  mounted() {
    this.poi = myApp.currentPoi;
    myApp.order = myApp.order || {}; // console.log(myApp.order);

    const self = this,
          app = this.$app,
          $ = this.$;
    this.getMenu();
    this.getAddresses();
    const sliderHour = app.range.create({
      el: '.range-slider-hours'
    }).on('change', (range, value) => {
      const v = value < 10 ? '0' + value : value;
      $('.dialog-time-hours').text(v);
      setColor(value);
    });
    app.range.create({
      el: '.range-slider-minutes'
    }).on('change', (range, value) => {
      const v = value < 10 ? '0' + value : value;
      $('.dialog-time-minutes').text(v);
    }); //console.log(myApp.currentPoi.info);

    const setColor = function (value) {
      value = value || self.ora;
      const h1 = self.dataDelivery == 'oggi' ? self.info.orarioOggi[0][1] : self.info.orarioDomani[0][1];
      const h2 = self.dataDelivery == 'oggi' ? self.info.orarioOggi[0][2] : self.info.orarioDomani[0][2];

      if (value < self.oraMin || value > self.oraMax || value > h1 && value < h2 || !self.oraMin && !self.oraMax) {
        $('.dialog-time-hours, .dialog-time-minutes, .dialog-time-sep').addClass('text-color-red');
        $('.dialog-hour-message').text(lng.closed);
        self.isClosed = true;
      } else {
        $('.dialog-time-hours, .dialog-time-minutes, .dialog-time-sep').removeClass('text-color-red');
        $('.dialog-hour-message').text('');
        self.isClosed = false;
      }
    }; // controlla e imposta giorni e ore di apertura / chiusura


    const now = new Date();
    const weekday = now.getDay();
    const weekday2 = weekday < 6 ? weekday + 1 : 0;
    self.info.oggiAperto = !myApp.currentPoi.info.weekdays[weekday] && !self.isClosed;
    self.info.domaniAperto = !myApp.currentPoi.info.weekdays[weekday2];
    const orariOggi = [myApp.currentPoi.info.opening[weekday].morning, myApp.currentPoi.info.opening[weekday].evening];
    const orariDomani = [myApp.currentPoi.info.opening[weekday2].morning, myApp.currentPoi.info.opening[weekday2].evening];
    const hOggi = [];
    const mOggi = [];
    const hDomani = [];
    const mDomani = [];
    self.dataDelivery = self.info.oggiAperto ? 'oggi' : 'domani';

    for (let i = 0; i < 2; i++) {
      if (orariOggi[i]) {
        let a = orariOggi[i].split('-');
        let aMin = a[0].split(':');
        let aMax = a[1].split(':');
        hOggi.push(aMin[0], aMax[0]);
        mOggi.push(aMin[1], aMax[1]);
        self.info.orarioOggi = [hOggi, mOggi];
      }

      if (orariDomani[i]) {
        let b = orariDomani[i].split('-');
        let bMin = b[0].split(':');
        let bMax = b[1].split(':');
        hDomani.push(bMin[0], bMax[0]);
        mDomani.push(bMin[1], bMax[1]);
        self.info.orarioDomani = [hDomani, mDomani];
      }
    }

    self.oraMin = (self.info.oggiAperto ? hOggi[0] || 0 : hDomani[0] || 0) * 1;
    self.oraMax = (self.info.oggiAperto ? hOggi[3] || 23 : hDomani[3] || 23) * 1;
    self.info.orarioOggi = self.info.orarioOggi || [[0, 12, 13, 23]];
    self.info.orarioDomani = self.info.orarioDomani || [[0, 12, 13, 23]];
    const h1 = self.dataDelivery == 'oggi' ? self.info.orarioOggi[0][1] : self.info.orarioDomani[0][1];
    const h2 = self.dataDelivery == 'oggi' ? self.info.orarioOggi[0][2] : self.info.orarioDomani[0][2];

    if (!self.info.oggiAperto || self.ora < self.oraMin || self.ora > self.oraMax || self.ora > h1 && self.ora < h2) {
      self.isClosed = true;
    } else {
      self.isClosed = false;
    }

    self.$tick().then(self.updateInfo);
    app.popup.create({
      el: '.popup-detail-order',
      swipeToClose: false,
      on: {
        close() {
          const closed = !self.checkDateTime(new Date());
          self.$setState({
            isClosed: closed
          });
        },

        open() {
          var price = 0;
          var ta = true;
          var del = true;
          var q = 0;

          var setDeliveryPrice = function () {
            if ($('#order-delivery').prop('checked')) {
              self.menu.menu_settings.order_min_free_delivery = self.menu.menu_settings.order_min_free_delivery || 0;
              const cond1 = self.menu.menu_settings.order_min_free_delivery * 1 == 0;
              const cond2 = self.menu.menu_settings.order_min_free_delivery * 1 > 0 && price < self.menu.menu_settings.order_min_free_delivery * 1;
              if (cond1 || cond2) self.delivery_price = self.menu.menu_settings.delivery_price * 1;else self.delivery_price = 0;
              $('#delivery-price').html(self.cur + ' ' + self.delivery_price);
            } else {
              self.delivery_price = 0;
              $('#delivery-price').html('');
            }

            self.$setState({
              total_price: self.order_price + self.delivery_price
            });
          };

          var setDeliveryEnabled = function () {
            const delivery_el = $('#order-delivery');
            const parent = delivery_el.parent();
            const label = $('label[for="order-delivery"]');

            if (self.delivery_enabled && self.order_price < (self.menu.menu_settings.delivery_order_min || 0)) {
              delivery_el.prop('disabled', true);
              parent.addClass('disabled');
              label.addClass('disabled');
            } else if (self.delivery_enabled) {
              delivery_el.prop('disabled', false);
              parent.removeClass('disabled');
              label.removeClass('disabled');
            }
          };

          for (let i in myApp.order) {
            q += myApp.order[i].q;

            if (myApp.order[i].q > 0) {
              price += myApp.order[i].price * myApp.order[i].q;
              if (!myApp.order[i].takeaway) ta = false;
              if (!myApp.order[i].delivery) del = false;
            }
          }

          if ($('#filter-all').prop('checked')) {
            ta = false;
            del = false;
          }

          if (q == 0 && self.hasMenu) {
            app.popup.close();
            app.dialog.alert(lng.orderMesssageError);
          }

          self.info.orarioOggi = self.info.orarioOggi || [[0, 12, 13, 23]];
          self.info.orarioDomani = self.info.orarioDomani || [[0, 12, 13, 23]];
          self.$setState({
            order: myApp.order,
            order_price: price,
            order_takeaway_enabled: ta,
            order_delivery_enabled: del,
            oraMin: (self.dataDelivery == 'oggi' ? self.info.orarioOggi[0][0] : self.info.orarioDomani[0][0]) * 1,
            oraMax: (self.dataDelivery == 'oggi' ? self.info.orarioOggi[0][3] : self.info.orarioDomani[0][3]) * 1
          }).then(() => {
            self.updateInfo();
            app.range.get('.range-slider-hours').emit('change');
            $('#order-delivery').prop('checked', $('#filter-delivery').prop('checked')).change(() => {
              if ($('#order-delivery').prop('checked')) {
                $('#order-takeaway').prop('checked', false);
              }

              setDeliveryPrice();
            });
            $('#order-takeaway').prop('checked', $('#filter-takeaway').prop('checked')).change(() => {
              if ($('#order-takeaway').prop('checked')) {
                $('#order-delivery').prop('checked', false);
              }

              setDeliveryPrice();
              self.setDelivery();
            });
            setDeliveryPrice();
            setDeliveryEnabled();
          });
        }

      }
    });
  },

  on: {
    pageBeforeRemove() {
      myApp.order = null;
    },

    pageBeforeIn(e, page) {
      if (!this.$route.query.onlyview && !this.$route.query.booking) {
        this.$app.popup.open('.popup-filter');
      }

      if (!this.$route.query.onlyview) {
        var aOpen = [];

        if (myApp.currentPoi.info && myApp.currentPoi.info.opening) {
          for (let i = 0; i < myApp.currentPoi.info.opening.length; i++) {
            if (myApp.currentPoi.info.opening[i]) {
              let a, b;

              if (myApp.currentPoi.info.opening[i].morning) {
                a = myApp.currentPoi.info.opening[i].morning.split('-');
              }

              if (myApp.currentPoi.info.opening[i].evening) {
                b = myApp.currentPoi.info.opening[i].evening.split('-');
              }

              aOpen.push({
                a: a ? a[0] : false,
                b: a ? a[1] : false,
                c: b ? b[0] : false,
                d: b ? b[1] : false
              });
            } else {
              aOpen.push({
                a: false,
                b: false,
                c: false,
                d: false
              });
            }
          }
        } else {
          for (let i = 0; i < 7; i++) {
            aOpen.push({
              a: false,
              b: false,
              c: false,
              d: false
            });
          }

          this.closed = true;
        }

        this.opened = aOpen;
        this.isClosed = !this.checkDateTime(new Date());
      }
    }

  },
  id: 'b03dca0299',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page">\n    <div class="navbar">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner sliding">\n        <div class="left">\n          <a href="#" class="link back">\n            <i class="icon icon-back"></i>\n            <span class="if-not-md">Back</span>\n          </a>\n        </div>\n        <div class="title">Digital menu & Price List</div>\n        <div class="right">\n          <a href="#" data-actions=".actions-translate" class="actions-open">\n            <img  width="28" src="static/img/flag_translate.png" alt=""/>\n          </a>\n        </div>\n      </div>\n    </div>\n    <div class="page-content" style="padding-bottom: 33vh">\n\n      <div class="actions-modal actions-translate">\n        <div class="list">\n          <ul>\n            <li>\n              <a href="#" @click="translate(\'en\')" class="item-link item-content actions-close">\n                <div class="item-media">\n                  <img width="28" src="static/img/flag_en.png" alt=""/>\n                </div>\n                <div class="item-inner">English</div>\n              </a>\n            </li>\n            <li>\n              <a href="#" @click="translate(\'fr\')"  class="item-link item-content actions-close">\n                <div class="item-media">\n                  <img width="28" src="static/img/flag_fr.png" alt=""/>\n                </div>\n                <div class="item-inner">Français</div>\n              </a>\n            </li>\n            <li>\n              <a href="#" @click="translate(\'it\')"  class="item-link item-content actions-close">\n                <div class="item-media">\n                  <img width="28" src="static/img/flag_it.png" alt=""/>\n                </div>\n                <div class="item-inner">Italiano</div>\n              </a>\n            </li>\n            <li>\n              <a href="#" @click="translate(\'es\')"  class="item-link item-content actions-close">\n                <div class="item-media">\n                  <img width="28" src="static/img/flag_es.png" alt=""/>\n                </div>\n                <div class="item-inner">Español</div>\n              </a>\n            </li>\n            <li>\n              <a href="#" @click="translate(\'de\')"  class="item-link item-content actions-close">\n                <div class="item-media">\n                  <img width="28" src="static/img/flag_de.png" alt=""/>\n                </div>\n                <div class="item-inner">Deutsche</div>\n              </a>\n            </li>\n            <li>\n              <a href="#" @click="translate(\'-\')"  class="item-link item-content actions-close">\n                <div class="item-media">\n                  <img width="28" src="static/img/flag_translate.png" alt=""/>\n                </div>\n                <div class="item-inner text-color-imc">';
      r += c(ctx_1.lng.originalLanguage, ctx_1);
      r += '</div>\n              </a>\n            </li>\n          </ul>\n        </div>\n      </div>\n\n      <!-- popup iniziale -->\n      <div class="popup popup-filter">\n        <div class=\'text-align-right margin-top padding-top\'>\n          <a class=\'link popup-close back text-uppercase padding\' href=\'#\'>\n            ';
      r += c(ctx_1.lng.close, ctx_1);
      r += ' &nbsp; <i class="icon f7-icons">xmark_circle_fill</i></a>\n\n        </div>\n        <div class="display-flex justify-content-center align-items-center h-100" style="max-width: 450px; margin: -45px auto auto auto">\n          <div class="row block">\n            <div class="col-50 text-align-center ';
      r += Template7Helpers.js.call(ctx_1, 'this.menu.takeaway ? "" : "disabled"', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '" @click="filter2(\'takeaway\')">\n              <img width=\'100%\' class=\'vertical-align-middle rounded-15\' src="static/menu/takeaway.png" alt=""/> \n              <h4>Take away</h4>\n            </div>\n            <div class="col-50 text-align-center ';
      r += Template7Helpers.js.call(ctx_1, 'this.menu.delivery ? "" : "disabled"', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '" @click="filter2(\'delivery\')">\n              <img width=\'100%\' class=\'vertical-align-middle rounded-15\' src="static/menu/delivery.png" alt=""/> \n              <h4>Delivery</h4>\n            </div>\n            ';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.isClosed, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            ';
          r += Template7Helpers.unless.call(ctx_2, ctx_2.menu.menu_settings.takeaway_delivery_only, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n            <div class="col-100 text-align-center ';
              r += c(ctx_3.foodDelivery, ctx_3);
              r += '" @click="filter2(\'table\')">\n              <div style="width: 100%; height: 50%; background: #4917df; border-radius: 15px">\n                <img width=\'50%\' class=\'vertical-align-middle\' src="static/menu/restaurant';
              r += Template7Helpers.if.call(ctx_3, ctx_3.isClosed, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += 'closed';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '.png" alt=""/> \n              </div>\n              <h4>';
              r += c(ctx_3.lng.atTheTable, ctx_3);
              r += '</h4>\n            </div>\n            ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n          </div>\n        </div>\n      </div>\n\n      <div class="hidden">\n        <div class=\'row text-align-center padding-vertical-half\'>\n          <div class=\'col\'>\n            <img width=\'28\' class=\'vertical-align-middle rounded\' src="static/menu/takeaway.png" alt=""/> \n            <label class="checkbox padding-left-half">\n              <input @change=\'filterTakeaway\' id=\'filter-takeaway\' ';
      r += Template7Helpers.js.call(ctx_1, "this.menu.menu_settings.takeaway_delivery_only ? 'checked'  : ''", {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' type="checkbox">\n              <i class="icon-checkbox"></i>\n            </label>\n            <br> Take away\n          </div>\n          <div class=\'col\'>\n            <img width=\'28\' class=\'vertical-align-middle rounded\' src="static/menu/delivery.png" alt=""/> \n            <label class="checkbox padding-left-half">\n              <input @change=\'filterDelivery\' id=\'filter-delivery\' type="checkbox">\n              <i class="icon-checkbox"></i>\n            </label>\n            <br> Delivery\n          </div>\n          ';
      r += Template7Helpers.js_if.call(ctx_1, "!this.menu.menu_settings.takeaway_delivery_only && !this.isClosed", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <div class=\'col\'>\n            <img width=\'28\' class=\'vertical-align-middle rounded\' src="static/menu/restaurant.png" alt=""/> \n            <label class="checkbox padding-left-half">\n              <input @change=\'filterAll\' id=\'filter-all\' checked type="checkbox">\n              <i class="icon-checkbox"></i>\n            </label>\n            <br> ';
          r += c(ctx_2.lng.atTheTable, ctx_2);
          r += '\n          </div>\n          ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n        </div>\n        <hr>\n      </div>    \n\n      <!-- each categories -->\n      ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.menu.categories, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n      ';
          r += Template7Helpers.js_if.call(ctx_2, "this.items.length", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n      <h3 class="padding-left text-uppercase">\n        <img src="static/cards.svg" width="12">\n        ';
              r += c(ctx_3.caption[lng.language], ctx_3);
              r += '\n      </h3> \n\n      <!-- each category.items -->\n      ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.items, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n      ';
                  r += Template7Helpers.if.call(ctx_4, ctx_4.visible, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n\n      <input type=\'hidden\' id="item-';
                      r += c(ctx_5.id, ctx_5);
                      r += '" value=\'';
                      r += Template7Helpers.js.call(ctx_5, "JSON.stringify(this)", {
                        hash: {},
                        data: data_5 || {},
                        fn: function empty() {
                          return '';
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [ctx_4, ctx_3, ctx_2, ctx_1]
                      });
                      r += '\'>\n      <div class="card-menu-item">\n        <div @click="showImage" \n              data-categoriesIndex="';
                      r += c(ctx_5.catIndex, ctx_5);
                      r += '"\n              data-index="';
                      r += c(data_5 && data_5.index, ctx_5);
                      r += '"\n              class="menu-item-image ';
                      r += Template7Helpers.if.call(ctx_5, root.onlyView, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += 'menu-item-image-small';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [ctx_4, ctx_3, ctx_2, ctx_1]
                      });
                      r += Template7Helpers.if.call(ctx_5, root.booking, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += 'menu-item-image-medium';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [ctx_4, ctx_3, ctx_2, ctx_1]
                      });
                      r += '" \n              style="background-image: url(';
                      r += c(ctx_5.images[0] || 'static/no-image.png', ctx_5);
                      r += ')"></div>\n        <div class="menu-item-price">';
                      r += c(root.cur, ctx_5);
                      r += ' ';
                      r += c(ctx_5.price, ctx_5);
                      r += '</div>\n        <div class="menu-item-caption item-';
                      r += c(ctx_5.id, ctx_5);
                      r += '-caption" @click="openExtend(\'';
                      r += c(ctx_5.id, ctx_5);
                      r += '\'">';
                      r += c(ctx_5.caption, ctx_5);
                      r += '</div>\n        <div class="menu-item-description-short item-';
                      r += c(ctx_5.id, ctx_5);
                      r += '-description" @click="openExtend(\'';
                      r += c(ctx_5.id, ctx_5);
                      r += '\'">';
                      r += c(ctx_5.description, ctx_5);
                      r += '</div>\n        <!-- sezione ordine -->\n        ';
                      r += Template7Helpers.unless.call(ctx_5, root.onlyView, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n        <div class="menu-item-order">\n          <span  @click="menuSubtract(\'';
                          r += c(ctx_6.id, ctx_6);
                          r += '\')" class="menu-item-button-minus inline-block"><i class="icon f7-icons">minus_circle_fill</i></span>\n          <span id="menu-item-q-';
                          r += c(ctx_6.id, ctx_6);
                          r += '" class="menu-item-order-q inline-block">0</span>\n          <span  @click="menuAdd(\'';
                          r += c(ctx_6.id, ctx_6);
                          r += '\')" class="menu-item-button-plus inline-block"><i class="icon f7-icons">plus_circle_fill</i></span>\n        </div> <!-- /sezione ordine -->\n        ';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [ctx_4, ctx_3, ctx_2, ctx_1]
                      });
                      r += '\n        ';
                      r += Template7Helpers.unless.call(ctx_5, root.booking, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n        <div class=\'row\'>\n          <div class=\'col\'>\n            ';
                          r += Template7Helpers.if.call(ctx_6, ctx_6.glutenfree, {
                            hash: {},
                            data: data_6 || {},
                            fn: function (ctx_7, data_7) {
                              var r = '';
                              r += '<img width=\'24\' class="rounded" src="static/menu/glutenfree.png" alt=""/>';
                              return r;
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                          });
                          r += '\n            ';
                          r += Template7Helpers.if.call(ctx_6, ctx_6.takeaway, {
                            hash: {},
                            data: data_6 || {},
                            fn: function (ctx_7, data_7) {
                              var r = '';
                              r += '<img width=\'24\' class="rounded" src="static/menu/takeaway.png" alt=""/>';
                              return r;
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                          });
                          r += '\n            ';
                          r += Template7Helpers.if.call(ctx_6, ctx_6.delivery, {
                            hash: {},
                            data: data_6 || {},
                            fn: function (ctx_7, data_7) {
                              var r = '';
                              r += '<img width=\'24\' class="rounded" src="static/menu/delivery.png" alt=""/>';
                              return r;
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                          });
                          r += '\n            ';
                          r += Template7Helpers.if.call(ctx_6, ctx_6.onsite, {
                            hash: {},
                            data: data_6 || {},
                            fn: function (ctx_7, data_7) {
                              var r = '';
                              r += '<img width=\'24\' class="rounded" src="static/menu/onsite.png" alt=""/>';
                              return r;
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                          });
                          r += '\n          </div>\n          ';
                          r += Template7Helpers.js_if.call(ctx_6, "this.description || this.hasAllergens", {
                            hash: {},
                            data: data_6 || {},
                            fn: function (ctx_7, data_7) {
                              var r = '';
                              r += '\n          <div class="col menu-item-open-icon" @click="openExtend(\'';
                              r += c(ctx_7.id, ctx_7);
                              r += '\'">\n            <i class="icon f7-icons">chevron_compact_down</i>\n          </div>\n          ';
                              return r;
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                          });
                          r += '\n        </div>\n\n\n        <div style="clear:both"></div>\n        <!-- parte nascosta -->\n        <div class="menu-item-extend hidden" @click="openExtend" data-id="';
                          r += c(ctx_6.id, ctx_6);
                          r += '">\n          <div class=\'item-';
                          r += c(ctx_6.id, ctx_6);
                          r += '-description\'>';
                          r += c(ctx_6.description, ctx_6);
                          r += '</div>\n          <div>\n            ';
                          r += Template7Helpers.if.call(ctx_6, ctx_6.glutenfree, {
                            hash: {},
                            data: data_6 || {},
                            fn: function (ctx_7, data_7) {
                              var r = '';
                              r += '<span class="badge color-imc margin-top-half">Gluten Free</span> ';
                              return r;
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                          });
                          r += '\n            <!-- ';
                          r += Template7Helpers.if.call(ctx_6, ctx_6.takeaway, {
                            hash: {},
                            data: data_6 || {},
                            fn: function (ctx_7, data_7) {
                              var r = '';
                              r += '<span class="badge color-imc margin-top-half">Take Away</span> ';
                              return r;
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                          });
                          r += '\n            ';
                          r += Template7Helpers.if.call(ctx_6, ctx_6.delivery, {
                            hash: {},
                            data: data_6 || {},
                            fn: function (ctx_7, data_7) {
                              var r = '';
                              r += '<span class="badge color-imc margin-top-half">Delivery</span> ';
                              return r;
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                          });
                          r += '  --> \n          </div>\n          <!-- <div class="menu-item-description">';
                          r += c(ctx_6.description, ctx_6);
                          r += '</div> -->\n          ';
                          r += Template7Helpers.if.call(ctx_6, ctx_6.hasAllergens, {
                            hash: {},
                            data: data_6 || {},
                            fn: function (ctx_7, data_7) {
                              var r = '';
                              r += '\n          <strong>';
                              r += c(root.lng.allergens_caption, ctx_7);
                              r += '</strong>\n          ';
                              return r;
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                          });
                          r += '\n          <div class="menu-item-allergens">\n            ';
                          r += Template7Helpers.each.call(ctx_6, ctx_6.allergens, {
                            hash: {},
                            data: data_6 || {},
                            fn: function (ctx_7, data_7) {
                              var r = '';
                              r += '\n            <div class="text-align-center padding-half">\n              <img id="';
                              r += c(data_7 && data_7.key, ctx_7);
                              r += '" width="50" src="static/allergy-icons/';
                              r += c(data_7 && data_7.key, ctx_7);
                              r += '/';
                              r += c(data_7 && data_7.key, ctx_7);
                              r += '_red_200x200.png"/> <br>\n              <div class="small">';
                              r += Template7Helpers.js.call(ctx_7, "lng.allergens[@key]", {
                                hash: {},
                                data: data_7 || {},
                                fn: function empty() {
                                  return '';
                                },
                                inverse: function empty() {
                                  return '';
                                },
                                root: root,
                                parents: [ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                              });
                              r += '</div>\n            </div>\n            ';
                              return r;
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                          });
                          r += '\n          </div>\n\n        </div> <!-- /parte nascosta -->\n\n        ';
                          return r;
                        },
                        inverse: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n        <div class="row">\n          <div class="col menu-item-open-icon" @click="openExtend(\'';
                          r += c(ctx_6.id, ctx_6);
                          r += '\'">\n            <i class="icon f7-icons">chevron_compact_down</i>\n          </div>\n        </div>\n        <!-- parte nascosta -->\n        <div class="menu-item-extend hidden" @click="openExtend" data-id="';
                          r += c(ctx_6.id, ctx_6);
                          r += '">\n          <div class=\'item-';
                          r += c(ctx_6.id, ctx_6);
                          r += '-description\'>';
                          r += c(ctx_6.description, ctx_6);
                          r += '</div>\n        </div> <!-- /parte nascosta -->\n\n        ';
                          return r;
                        },
                        root: root,
                        parents: [ctx_4, ctx_3, ctx_2, ctx_1]
                      });
                      r += '\n      </div>\n\n      ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += ' ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += ' <!-- end each category.items --> ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n      ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' <!-- end each categories -->\n\n      <!-- disclaimer -->\n      ';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.onlyView, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n      <div class=\'block\'>\n\n        ';
          r += Template7Helpers.unless.call(ctx_2, ctx_2.booking, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n        <div id="card-disclaimer" class="card">\n          <div class="card-content card-content-padding">\n            <h4>';
              r += c(ctx_3.lng.menuDisclaimerTitle, ctx_3);
              r += '</h4>\n            <p>';
              r += c(ctx_3.lng.menuDisclaimerText, ctx_3);
              r += '</p>\n            <div class="row">\n              <div class="col-40 text-align-left">\n                <a href="/chat/';
              r += c(ctx_3.idpoi, ctx_3);
              r += '/" class="button button-large button-fill button-circle bg-color-primary text-color-imc">\n                  <i class="icon f7-icons ios-only">chat_bubble_text_fill</i>\n                  <i class="icon material-icons md-only">chat</i></a>\n              </div>\n              <div class="col-60">\n                <div class=\'text-align-right\'>\n                  <label for="igetit"> ';
              r += c(ctx_3.lng.iGetIt, ctx_3);
              r += ' </label>\n                  <label class="checkbox">\n                    <input id=\'igetit\' type="checkbox">\n                    <i class="icon-checkbox"></i>\n                  </label>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n        ';
          r += Template7Helpers.js_if.call(ctx_2, "this.booking", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n        <div class="padding" id="datetime-booking"></div>\n        <button @click="bookingFor" \n                 class="button button-large button-fill button-round button-raised">\n          ';
              r += c(ctx_3.lng.select, ctx_3);
              r += ' ';
              r += c(ctx_3.lng.dateAndTime, ctx_3);
              r += ' \n        </button>\n\n        ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.deliveryTS, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n        <button   @click="openPopup" \n                   class="button button-large button-fill button-round button-raised bg-color-imc text-color-primary margin-top-half">\n          ';
                  r += c(ctx_4.lng.book, ctx_4);
                  r += ' \n        </button>\n        ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n\n        ';
              r += Template7Helpers.js_if.call(ctx_3, "this.info.oggiAperto || this.info.domaniAperto", {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n\n        ';
              r += Template7Helpers.js_if.call(ctx_3, "this.info.oggiAperto || this.info.domaniAperto", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n        <div class="menu-buttons-bottom-group">\n          <button id=\'btn-order\' @click="openPopup" \n                  class="button button-large button-fill button-round button-raised bg-color-imc text-color-primary">\n            ';
                  r += c(ctx_4.lng.orderNow, ctx_4);
                  r += '\n          </button>\n        </div>\n        ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n        <h3 class="text-color-red text-align-center">';
                  r += c(ctx_4.lng.closedTodayAndTomorrow, ctx_4);
                  r += '</h3>\n        ';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n        <div style="padding-bottom: 60px"></div>\n\n      </div> <!-- /disclaimer -->\n      ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n    </div>\n\n    <!-- Popup Dettaglio ordine -->\n    <div class="popup popup-detail-order popup-tablet-fullscreen">\n      <div class="view">\n        <div class="page">\n          <div class="navbar bg-color-imc">\n            <div class="navbar-bg bg-color-imc"></div>\n            <div class="navbar-inner bg-color-imc">\n              <div class="title center sliding"> ';
      r += c(ctx_1.lng.orderDetail, ctx_1);
      r += ' </div>\n              <div class="right">\n                <a class="link popup-close">\n                  <i class="icon f7-icons text-color-primary">multiply_circle_fill</i>\n                </a>\n              </div>\n            </div>\n          </div>\n\n          <div class="page-content bg-color-white">\n\n            <div class="list no-hairline no-border no-hairline-top no-hairline-bottom">\n              <ul>\n                ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.booking, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <li class="padding">\n                  ';
          r += c(ctx_2.lng.booking, ctx_2);
          r += '\n                  ';
          r += Template7Helpers.js.call(ctx_2, "new Date(this.deliveryTS).toString()", {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                </li>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n                ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.order, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                ';
          r += Template7Helpers.js_if.call(ctx_2, "this.q > 0", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <li class="row padding-horizontal">\n                  <div class="col-50 text-align-left">';
              r += c(ctx_3.caption, ctx_3);
              r += '</div>\n                  <div class="col-20 text-align-right">';
              r += c(ctx_3.q, ctx_3);
              r += ' X</div>\n                  <div class="col-30 text-align-right">';
              r += c(root.cur, ctx_3);
              r += ' ';
              r += Template7Helpers.js.call(ctx_3, "(this.price *1).toFixed(2).toLocaleString()", {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</div>\n                </li>\n                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' \n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                <li><hr></li>\n                <li class="row padding-horizontal">\n                  <div class="col-60 text-align-left text-bold">TOTALE ORDINE</div>\n                  <div class="col-40 text-align-right">';
      r += c(ctx_1.cur, ctx_1);
      r += ' ';
      r += c(ctx_1.order_price, ctx_1);
      r += '</div>\n                </li>\n                ';
      r += Template7Helpers.js_if.call(ctx_1, "this.order_takeaway_enabled || this.order_delivery_enabled", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <li> <hr> </li>\n                <li class="bold text-uppercase padding"><small>';
          r += c(ctx_2.lng.mode, ctx_2);
          r += '</small></li>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n                ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.order_takeaway_enabled, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <li class="padding-horizontal padding-vertical-half">\n                  <label class="checkbox">\n                    <input @change="setDelivery" id=\'order-takeaway\' type="checkbox">\n                    <i class="icon-checkbox"></i>\n                  </label>\n                  <label for="order-takeaway">Take Away</label>\n                </li>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                ';
      r += Template7Helpers.js_if.call(ctx_1, "this.order_takeaway_enabled && this.order_delivery_enabled", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <li class="padding-horizontal"> <hr> </li>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.order_delivery_enabled, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <li class="padding-horizontal padding-vertical-half row">\n                  <div class="col-60">\n                    <label class="checkbox">\n                      <input @change="setDelivery" id=\'order-delivery\' type="checkbox">\n                      <i class="icon-checkbox"></i>\n                    </label>\n                    <label for="order-delivery">Delivery</label>\n                  </div>\n                  <div class="col-40 text-align-right" id="delivery-price"></div>\n                </li>\n                <li class="padding-horizontal">\n                  <small>\n                    ';
          r += c(ctx_2.lng.order_min, ctx_2);
          r += ': ';
          r += c(ctx_2.cur, ctx_2);
          r += ' ';
          r += c(ctx_2.menu.menu_settings.delivery_order_min, ctx_2);
          r += ' <br>\n                    ';
          r += c(ctx_2.lng.price, ctx_2);
          r += ': ';
          r += c(ctx_2.cur, ctx_2);
          r += ' ';
          r += c(ctx_2.menu.menu_settings.delivery_price, ctx_2);
          r += ' <br>\n                    ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.menu.menu_settings.order_min_free_delivery, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    (';
              r += c(ctx_3.lng.order_min_free_delivery, ctx_3);
              r += ' >= ';
              r += c(ctx_3.cur, ctx_3);
              r += ' ';
              r += c(ctx_3.menu.menu_settings.order_min_free_delivery, ctx_3);
              r += ') <br>\n                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                    ';
          r += c(ctx_2.lng.acceptPaymentOnDelivery, ctx_2);
          r += ': ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.menu.menu_settings.delivery_cash, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += ' ';
              r += c(ctx_3.lng.yes, ctx_3);
              r += ' ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += ' ';
              r += c(ctx_3.lng.no, ctx_3);
              r += ' ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                  </small>\n                </li>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                <li><hr></li><!-- comment -->\n                <li class="padding bold text-uppercase row">\n                  <div class="col-60">';
      r += c(ctx_1.lng.total, ctx_1);
      r += '</div>\n                  <div class="col-40 text-align-right">\n                    ';
      r += c(ctx_1.cur, ctx_1);
      r += ' ';
      r += Template7Helpers.js.call(ctx_1, "(this.total_price || 0).toFixed(2).toLocaleString()", {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                  </div>\n                </li>\n              </ul>\n            </div>\n\n            <div class=\'block\'>\n              <div class="list">\n                <ul>\n                  <li class="item-content item-input">\n                    <div class="item-inner">\n                      <div class="item-title item-label">';
      r += c(ctx_1.lng.notes, ctx_1);
      r += '</div>\n                      <div class="item-input-wrap">\n                        <textarea id="order_notes" placeholder="';
      r += c(ctx_1.lng.orderNotes, ctx_1);
      r += '"></textarea>\n                        <span class="input-clear-button"></span>\n                      </div>\n                    </div>\n                  </li>\n                  ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.is_delivery, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                  <li class="item-content item-input">\n                    <div class="item-inner">\n                      <div class="item-title item-label">';
          r += c(ctx_2.lng.orderAdress, ctx_2);
          r += '</div>\n                      <div class="item-input-wrap">\n                        <select id="delivery-address">\n                          <option value="-">';
          r += c(ctx_2.lng.insert, ctx_2);
          r += '</option>\n                          ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.deliveryAddresses, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                          <option ';
              r += c(ctx_3.default_addr, ctx_3);
              r += ' value="';
              r += c(ctx_3.id, ctx_3);
              r += '">';
              r += c(ctx_3.val, ctx_3);
              r += '</option>\n                          ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                        </select>\n                      </div>\n                    </div>\n                  </li>\n                  ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                </ul> \n                ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.is_delivery, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <a class="button color-blue" @click="setDeliveryAddress" href="#">';
          r += c(ctx_2.lng.setDeliveryAddress, ctx_2);
          r += '</a>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n              </div>\n\n              ';
      r += Template7Helpers.js_if.call(ctx_1, "this.order_takeaway_enabled || this.order_delivery_enabled", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n              <div class="block">\n                <h3>';
          r += c(ctx_2.lng.order_text_1, ctx_2);
          r += '</h3>\n                <div class="row">\n                  <div class="col">\n                    <button @click="deliveryNow" class="button deliveryNow">';
          r += c(ctx_2.lng.order_text_2, ctx_2);
          r += '</button>\n                  </div>\n                  <div class="col">\n                    <button @click="deliveryFor" class="button deliveryFor">';
          r += c(ctx_2.lng.order_text_3, ctx_2);
          r += '</button>\n                  </div>\n                </div>\n                ';
          r += Template7Helpers.js_if.call(ctx_2, "this.deliveryTS", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <h4> ';
              r += Template7Helpers.js.call(ctx_3, "(new Date(this.deliveryTS)).toLocaleString()", {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</h4>\n                <p class="order_text_6">';
              r += c(ctx_3.lng.order_text_6, ctx_3);
              r += '.</p>\n                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n              </div>\n              ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n              ';
      r += Template7Helpers.js_if.call(ctx_1, "this.poi.info.paypal && this.menu.menu_settings.paypal_enabled && this.orderType !== 'onsite'", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n              <button @click="paypal" class="button button-fill button-large button-round margin-vertical-half">\n                ';
          r += c(ctx_2.lng.buyNowWith, ctx_2);
          r += ' \n                <img height="24" src="static/paypal-icon.svg" style="vertical-align: middle">\n                <img height="24" src="static/paypal.svg" style="vertical-align: middle">\n              </button>\n              <div class="text-align-center">\n                <img style="max-width: 90%"  @click="paypal"\n                     src="https://www.paypalobjects.com/webstatic/en_US/i/buttons/cc-badges-ppmcvdam.png" \n                     alt="Buy now with PayPal" />\n              </div>\n              ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n\n              <button @click=\'sendOrder\' \n                       class=\'button button-large button-fill button-round button-raised bg-color-imc text-color-primary\'>\n                ';
          r += c(ctx_2.lng.order_text_4, ctx_2);
          r += '\n              </button>\n\n              ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' \n\n              ';
      r += Template7Helpers.js_if.call(ctx_1, "this.poi.info.paypal && this.menu.menu_settings.paypal_enabled && this.menu.menu_settings.booking_cash && this.orderType !== 'onsite'", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n              <div class="margin-vertical text-align-center text-color-gray">\n                --------------------------- ';
          r += c(ctx_2.lng.or, ctx_2);
          r += ' ---------------------------\n              </div>\n\n              <button @click=\'sendOrder\'  \n                       class="button button-fill \n                       button-large \n                       button-round \n                       margin-vertical-half \n                       button-raised \n                       bg-color-imc \n                       text-color-primary">';
          r += c(ctx_2.lng.payOnDelivery, ctx_2);
          r += '</button>\n              ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n              ';
      r += Template7Helpers.if.call(ctx_1, false, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n              <button @click=\'sendOrder\' \n                       class=\'button button-large button-fill button-round button-raised bg-color-imc text-color-primary\'>\n                ';
          r += c(ctx_2.lng.order_text_4, ctx_2);
          r += '\n              </button>\n              ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n            </div>\n\n          </div>\n        </div>\n      </div>\n    </div> <!-- /Popup Dettaglio ordine -->\n\n    <!-- Popup setDeliveryAddress -->\n    <div class="popup popup-delivery-addr popup-tablet-fullscreen">\n      <div class="view">\n        <div class="page">\n          <div class="navbar bg-color-imc">\n            <div class="navbar-bg bg-color-imc"></div>\n            <div class="navbar-inner bg-color-deeppurple">\n              <div class="title center sliding"> ';
      r += c(ctx_1.lng.deliveryAddress, ctx_1);
      r += ' </div>\n              <div class="right">\n                <a class="link popup-close">\n                  <i class="icon f7-icons text-color-primary">multiply_circle_fill</i>\n                </a>\n              </div>\n            </div>\n          </div>\n\n          <div class="page-content bg-color-white">\n            <input type="hidden" name="delivery_address_id"/>\n            <div class="list">\n              <ul>\n                <li class="item-content item-input">\n                  <div class="item-inner">\n                    <div class="item-title item-label">';
      r += c(ctx_1.lng.select, ctx_1);
      r += ' ';
      r += c(ctx_1.lng.orderAdress, ctx_1);
      r += '</div>\n                    <div class="item-input-wrap">\n                      <select id="delivery-address-2" @change="changeDeliveryAddr">\n                        <option value="-">';
      r += c(ctx_1.lng.insert, ctx_1);
      r += ' ';
      r += c(ctx_1.lng.new, ctx_1);
      r += '</option>\n                        ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.deliveryAddresses, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        <option value="';
          r += c(data_2 && data_2.index, ctx_2);
          r += '">';
          r += c(ctx_2.val, ctx_2);
          r += '</option>\n                        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                      </select>\n                    </div>\n                  </div>\n                </li>\n                <li class="item-content item-input">\n                  <div class="item-inner">\n                    <div class="item-title item-label">';
      r += c(ctx_1.lng.poiLabels.address, ctx_1);
      r += '</div>\n                    <div class="item-input-wrap">\n                      <input type="text" name="delivery_address" required validate placeholder="';
      r += c(ctx_1.lng.insert, ctx_1);
      r += ' ';
      r += c(ctx_1.lng.poiLabels.address, ctx_1);
      r += '">\n                      <span class="input-clear-button"></span>\n                    </div>\n                  </div>\n                </li>\n                <li class="item-content item-input">\n                  <div class="item-inner">\n                    <div class="item-title item-label">';
      r += c(ctx_1.lng.poiLabels.CAP, ctx_1);
      r += '</div>\n                    <div class="item-input-wrap">\n                      <input type="text" name="delivery_cap" required validate placeholder="';
      r += c(ctx_1.lng.insert, ctx_1);
      r += ' ';
      r += c(ctx_1.lng.poiLabels.CAP, ctx_1);
      r += '">\n                      <span class="input-clear-button"></span>\n                    </div>\n                  </div>\n                </li>\n                <li class="item-content item-input">\n                  <div class="item-inner">\n                    <div class="item-title item-label">';
      r += c(ctx_1.lng.poiLabels.city, ctx_1);
      r += '</div>\n                    <div class="item-input-wrap">\n                      <input type="text" name="delivery_city" required validate placeholder="';
      r += c(ctx_1.lng.insert, ctx_1);
      r += ' ';
      r += c(ctx_1.lng.poiLabels.city, ctx_1);
      r += '">\n                      <span class="input-clear-button"></span>\n                    </div>\n                  </div>\n                </li>\n                <li class="item-content item-input">\n                  <div class="item-inner">\n                    <div class="item-title item-label">';
      r += c(ctx_1.lng.addressName, ctx_1);
      r += '</div>\n                    <div class="item-input-wrap">\n                      <input type="text" name="delivery_address_name" required validate placeholder="';
      r += c(ctx_1.lng.insert, ctx_1);
      r += ' ';
      r += c(ctx_1.lng.addressName, ctx_1);
      r += '">\n                      <span class="input-clear-button"></span>\n                    </div>\n                  </div>\n                </li>\n                <li class="item-content item-input">\n                  <div class="item-inner">\n                    <div class="item-title item-label">';
      r += c(ctx_1.lng.poiLabels.phone, ctx_1);
      r += '</div>\n                    <div class="item-input-wrap">\n                      <input type="tel" name="delivery_phone" required validate placeholder="';
      r += c(ctx_1.lng.insert, ctx_1);
      r += ' ';
      r += c(ctx_1.lng.poiLabels.phone, ctx_1);
      r += '">\n                      <span class="input-clear-button"></span>\n                    </div>\n                  </div>\n                </li>\n\n                <li class="item-content">\n                  <div class="item-inner">\n                    <div class="item-title">';
      r += c(ctx_1.lng.defaultAddress, ctx_1);
      r += '</div>\n                    <div class="item-after">\n                      <label class="toggle">\n                        <input name="delivery_default" type="checkbox">\n                        <span class="toggle-icon"></span>\n                      </label>\n                    </div>\n                  </div>\n                </li>\n              </ul> \n            </div>\n            <div class="block">\n              <button class="button button-large button-fill button-round button-raised bg-color-imc text-color-yellow" \n                      @click="insertDeliveryAddress">';
      r += c(ctx_1.lng.save, ctx_1);
      r += '</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div> <!-- /Popup setDeliveryAddress -->\n\n\n    <!-- dialog time -->\n    <div class="dialog dialog-time">\n\n      <button @click="deliveryToday" class="button deliveryToday">Oggi</button>\n      <button @click="deliveryTomorrow" class="button deliveryTomorrow">Domani</button>\n\n      <h3>';
      r += c(ctx_1.lng.hour, ctx_1);
      r += '</h3>\n\n      <span class="dialog-time-hours">';
      r += c(ctx_1.ora, ctx_1);
      r += '</span>\n      <span class="dialog-time-sep">:</span>\n      <span class="dialog-time-minutes">00</span>\n      <div  class="dialog-hour-message text-color-red text-uppercase bold" style="height: 1em"></div>\n\n      <div class="block">\n        <div class="text-align-left">Ore</div>\n        <div class="range-slider range-slider-hours"\n             data-min="';
      r += c(ctx_1.oraMin, ctx_1);
      r += '"\n             data-max="';
      r += c(ctx_1.oraMax, ctx_1);
      r += '"\n             data-step="1"\n             data-value="';
      r += c(ctx_1.ora, ctx_1);
      r += '"\n             data-scale="true"\n             data-scale-steps="1"\n             ></div>\n        <div style="height: 2em"></div>\n        <div class="text-align-left">Minuti</div>\n        <div class="range-slider range-slider-minutes"\n             data-min="0"\n             data-max="45"\n             data-step="15"\n             data-value="0"\n             data-scale="true"\n             data-scale-steps="1"\n             ></div>\n      </div>\n      <div class="row margin-half">\n        <div class="col">\n\n        </div>\n        <div class="col">\n          <a class="button button-large button-round button-fill bg-color-imc text-color-yellow icon-only" \n             @click="setHour"\n             href="#">\n            <i class="icon f7-icons">arrow_right</i>\n          </a>\n        </div>\n      </div>\n\n    </div> <!-- /dialog-time -->\n    <div id="map____5"></div>\n  </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    